import React, { forwardRef } from 'react';
import classNames from 'classnames';
import Button from '../Button';
import styles from './ToggleButton.module.css';

const ToggleButton = forwardRef(function ToggleButton(
  { name, checked = false, className, onChange, children, ...rest },
  forwardedRef
) {
  return (
    <Button
      ref={forwardedRef}
      className={classNames(styles.root, className)}
      size="x-small"
      component="label"
      start={<input type="checkbox" name={name} checked={checked} className={styles.checkbox} onChange={onChange} />}
      {...rest}
    >
      {children}
    </Button>
  );
});

export default ToggleButton;
